import * as React from 'react';
import { useDispatch } from 'react-redux';
import { INewbuildingBuilder, ISeller } from '../../types/newbuilding/builder';

import { trackOpenContacts } from '../../actions/analytics';

import { TThunkDispatch } from '../../types/redux';
import { ShowPhonesButton } from '../../components/MobileCall/ShowPhonesButton';
import { ShowPhonesModalContainer } from './ShowPhonesModal';

interface IShowPhonesContainerProps {
  builders: INewbuildingBuilder[];
  leadFactorySeller?: ISeller;
  placeType?: string;
  sellers: ISeller[];
}

export const ShowPhonesContainer: React.VFC<IShowPhonesContainerProps> = ({
  builders,
  leadFactorySeller,
  placeType = 'ShowPhone',
}) => {
  const [isModalOpen, setModalOpen] = React.useState(false);
  const dispatch = useDispatch<TThunkDispatch>();

  const onClick = React.useCallback(() => {
    setModalOpen(true);
    dispatch(trackOpenContacts());
  }, [dispatch, builders, placeType]);

  const label = leadFactorySeller ? 'Консультант' : 'Позвонить';

  return (
    <>
      <ShowPhonesButton label={label} onClick={onClick} />
      <ShowPhonesModalContainer isModalOpen={isModalOpen} closePhoneModal={() => setModalOpen(false)} />
    </>
  );
};
